import React, {PropTypes} from 'react';
import classNames from 'classnames';

const VirtualEventQuickList = ({
  entries,
  onSelect
}) => (
  <div className="list-group">
    {entries.map((item, index) => (
      <div
        key={index}
        className={classNames(
          "list-group-item hover-highlight",
          {"highlight animated flipInX": item.highlight}
        )}
        onClick={() => onSelect(item.id)}
      >
        <div className="list-group-item-inner-wrapper cursor-pointer">
          <div className="list-group-item-heading">{item.name}{' '}</div>
          <i className="fa fa-chevron-right" />
        </div>
      </div>
    ))}
  </div>
);

VirtualEventQuickList.propTypes = {
  entries: PropTypes.arrayOf(PropTypes.object),
  onSelect: PropTypes.func
};

export default VirtualEventQuickList;



// WEBPACK FOOTER //
// ./src/features/tournament/divisions/VirtualEventQuickList.jsx